import React from "react";
import { Input } from "@windmill/react-ui";

const InputAdhaar = ({
  register,
  trigger,
  defaultValue,
  required,
  name,
  label,
  type,
  placeholder,
  pattern,
  minLength,
  maxLength,
  value,
  readOnly,
  onChange,
}) => {
  // Validation rules
  const validation = {
    required: required === false ? false : `${label} is required!`,
    pattern: {
      value: pattern || /^\d{12}$/, // Default pattern for Aadhaar (12 digits)
      message: `${label} must be exactly 12 digits!`,
    },
    maxLength: {
      value: maxLength || 12,
      message: `Maximum Length ${maxLength || 12} digits!`,
    },
    minLength: {
      value: minLength || 12,
      message: `Minimum Length ${minLength || 12} digits!`,
    },
    validate: (value) => {
      if (
        typeof value === "string" &&
        value.trim() === "" &&
        required !== false
      ) {
        return `${label} is required!`;
      }
      if (type === "text" && name === "aadhaar_number" && required === true) {
        if (!/^\d+$/.test(value)) {
          return `${label} must contain only numbers!`;
        }
      }
      return true;
    },
  };

  // Restrict input to numbers only
  const handleInput = (event) => {
    event.target.value = event.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
    if (event.target.value.length > (maxLength || 12)) {
      event.target.value = event.target.value.slice(0, maxLength || 12); // Enforce maxLength
    }
  };

  return (
    <>
      <Input
        {...register(`${name}`, validation)}
        defaultValue={defaultValue}
        type={type}
        placeholder={placeholder}
        onInput={handleInput}
        required={required}
        name={name}
        // onBlur={() => trigger(`${name}`)}
        value={value}
        readOnly={readOnly}
        onChange={onChange}
        autoComplete="off"
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      />
    </>
  );
};

export default InputAdhaar;
